<template>
  <b-overlay :show="loading">
    <div
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="management"
      v-bind:style="{ 'background-image': 'url(' + imagenFondo + ') !important',
      'background-attachment': 'fixed',
      overflow: 'scroll'
    }"
    >
      <div>
        <img
          v-if="ingresoLogo"
          :src="ingresoLogo.imagen"
          id="logo"
          v-bind:style="logoStyle"
          alt="logo"
        />
        <h4 class="mb-5 text-white text-center">
          Verificación de identidad para firma electrónica
        </h4>
        <b-card>
          <verification-form-external-sign-api
            :cuUserData="cuUserData"
            @completed="onCompleted"
          />
        </b-card>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import VerificationFormExternalSignApi from "./components/VerificationFormExternalSignApi";
import { mapActions } from "vuex";
import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';

export default {
  components: { VerificationFormExternalSignApi },
  mixins: [PersonalizacionMixin],
  data() {
    return {
      cuUserData: {},
      loading: false,
    };
  },
  computed: {
    token() {
      const { token } = this.$route.params;
      return token;
    },
  },
  methods: {
    ...mapActions('Approvals', [
      'getCUInfo'
    ]),
    onCompleted() {
      const { token } = this.$route.params;
      const { idProceso } = this.$route.query;
      this.$router.push({
        name: 'signature-external-file',
        params: { token },
        query: { idProceso, provider: 'signapi' }
      });
    },
    async getProcessInfo() {
      try {
        this.loading = true;
        const idProceso = this.$route.query.idProceso;
        const response = await this.getCUInfo({
          processId: idProceso,
          action: 'info',
          domain: 'portal.escritoriodigital.cl',
          token: this.token,
        });
        this.loading = false;
        const { info } = response;
        this.cuUserData = {
          iut: info.RolUnico ? `${info.RolUnico.numero}-${info.RolUnico.DV}` : '',
          name: info.name ? info.name.nombres.join(' ') : '',
          lastName: info.name ? info.name.apellidos[0] : '',
          mothersLastName: info.name && info.name.apellidos[1] ? info.name.apellidos[1] : '',
          address: '',
          iutNumber: '',
          email: '',
          landline: '',
          phone: '',
          commune: '',
        };
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    }
  },
  async created() {
    await this.getProcessInfo();
  }
}
</script>
